<template>
  <div class="play-list">
    <div class="plan_control_list">
      <div class="control">
        <div class="left_button">
          <div class="control_order">
            <div style="margin-right: 10px; display: flex;align-items: center;" v-show="activeName=='third'">
              <el-switch v-model="isTimeRunning" active-color="#13ce66" inactive-color="#ff4949" @change="changeTimeRunning" :disabled="this.currentDetail.run_state==0">
              </el-switch>
              <template v-if="isTimeRunning">
                <span>{{$t('terminal.timeOpenTip')}}</span>
              </template>
              <template v-else>
                <span>{{$t('terminal.timeCloseTip')}}</span>
              </template>
            </div>
            <!-- <el-button type="primary" size="mini" v-if="this.currentTab=='third'" round
							@click.stop="uploadSchedule">同步至终端</el-button> -->
            <!-- <template v-if="this.currentTab=='second'">
							<el-button type="primary" size="small">+添加循环播放</el-button>
						</template>
						<template v-if="this.currentTab=='third'">
							<el-button type="primary" size="small">+添加定时播放</el-button>
						</template> -->
          </div>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="$t('terminal.programList')" name="first">
              <div class="list_table">
                <div class="table_content">
                  <el-table :data="current_program_list" style="width: 100%" height="100%" v-loading="detail_list_loading">
                    <el-table-column type="index" :label="$t('terminal.no')" width="150">
                    </el-table-column>
                    <el-table-column prop="name" :label="$t('terminal.proName')">
                    </el-table-column>
                    <el-table-column :label="$t('terminal.playTime')">
                      <template slot-scope="scope">
                        {{ msFormatting(scope.row.playTime) }}
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('terminal.operate')">
                      <template slot-scope="scope">
                        <div class="con_button">
                          <i class="i_img" style="width: 25px;height: 25px;">
                            <template v-if="!scope.row.play">
                              <img style="width: 25px;height: 25px;" src="@/assets/images/release/release_play_hover.png" @click="handleStopPlan(scope.row,1)" />
                            </template>
                            <template v-else>
                              <img style="width: 25px;height: 25px;" src="@/assets/images/release/release_pause_hover.png" @click="handleNoPlan" />
                            </template>
                          </i>
                          <i class="i_img">
                            <img src="@/assets/images/public/public_delete.png" @click="handlePlanDelete(scope.row)" />
                          </i>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('terminal.loop')" name="second">
              <div class="list_table">
                <div class="table_content">
                  <el-table :data="this.sheet_list" height="100%" row-key="key" default-expand-all :tree-props="{children: 'programlist'}" style="width: 100%" v-loading="detail_list_loading">
                    <el-table-column prop="index" :label="$t('terminal.no')" width="150">
                    </el-table-column>
                    <el-table-column prop="name" :label="$t('terminal.proName')">
                    </el-table-column>
                    <el-table-column :label="$t('terminal.excSta')">
                      <template slot-scope="scope">
                        <template v-if="(typeof (scope.row.playTime)!='string')&&scope.row.playTime!=0">
                          <!-- {{scope.row.playTime.toString()}} -->
                          {{typeof(scope.row.finaldata)=='number' ? scope.row.finaldata +'次' : scope.row.finaldata.toString()}}
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('terminal.operate')">
                      <template slot-scope="scope">
                        <template v-if="(typeof (scope.row.playTime)=='string')">
                          <div class="con_button">
                            <i class="i_img" style="width: 25px;height: 25px;">
                              <template v-if="!scope.row.play">
                                <img style="width: 25px;height: 25px;" src="@/assets/images/release/release_play_hover.png" @click="handleStopPlan(scope.row,2)" />
                              </template>
                              <template v-else>
                                <img style="width: 25px;height: 25px;" src="@/assets/images/release/release_pause_hover.png" @click="handleNoPlan" />
                              </template>
                            </i>
                            <i class="i_img">
                              <img src="@/assets/images/public/public_delete.png" @click="handlePlanDelete(scope.row)" />
                            </i>
                          </div>
                        </template>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('terminal.timingPlay')" @click="getScheduleProgramList()" name="third">
              <div class="list_table">
                <div class="table_content">
                  <el-table :data="this.get_schedule_program_merge" height="100%" style="width: 100%" v-loading="detail_list_loading">
                    <el-table-column type="index" :label="$t('terminal.no')" width="150">
                    </el-table-column>
                    <!-- <el-table-column prop="name" label="指令类型">
										</el-table-column> -->
                    <el-table-column prop="name" :label="$t('terminal.proName')">
                    </el-table-column>
                    <el-table-column prop="playTime" :label="$t('terminal.excTime')">
                      <template slot-scope="scope">
                        {{`${scope.row.startTime}-${scope.row.endTime}`}}
                      </template>
                    </el-table-column>
                    <el-table-column prop="playTime" :label="$t('terminal.dateOk')">
                      <template slot-scope="scope">
                        <template v-if="scope.row.isDateLimit">
                          {{`${scope.row.dateStart}-${scope.row.dateEnd}`}}
                        </template>
                        <template v-else>{{$t('terminal.noLimit')}}</template>
                      </template>
                    </el-table-column>
                    <el-table-column prop="playTime" :label="$t('terminal.isWeekLi')">
                      <template slot-scope="scope">
                        <template v-if="scope.row.isWeekLimit">
                          {{scope.row.weekList}}
                        </template>
                        <template v-else>{{$t('terminal.noLimit')}}</template>
                      </template>
                    </el-table-column>
                    <el-table-column prop="playTime" :label="$t('terminal.playCount')">
                      <template slot-scope="scope">
                        {{scope.row.playCount}}
                      </template>
                    </el-table-column>
                    <!-- 需要使用同步到终端 -->
                    <!-- <el-table-column label="操作">  
											<template slot-scope="scope">
												<div class="con_button">
													<i class="i_img">
														<img src="@/assets/images/public/public_edit.png"
															@click="handlePlan(scope.$index,scope.row)" />
													</i>
													<i class="i_img">
														<img src="@/assets/images/public/public_delete.png"
															@click="handleDeleteSchedule(scope.$index,scope.row)" />
													</i>
												</div>
											</template>
										</el-table-column> -->

                  </el-table>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <del-dialog :title="$t('terminal.proDelete')" :dialogVisible="deletePlanVisible" @closeDialog="confirmDeletePlan" :isAppend="true">
      <div style="width: 100%;text-align: center;height: 40px;padding-top: 40px;font-size: 16px;">{{$t('terminal.proDeleteTip')}}</div>
    </del-dialog>
  </div>
</template>

<script>
const detailCommand = "/admin/Command/deviceCommand";
import { msFormatting } from "@/assets/scripts/dateFormatting";
import {
  secToHMS,
  daysWeek,
  sendCommandKp
} from "@/assets/scripts/publicFunction";
import {
  uriEncode
} from "@/assets/scripts/uriEncode";
import DelDialog from "@/components/basics/DelDialogConfirm";

export default {
  name: "PlayList",
  props: {
    currentDetail: {
      type: Object
    }
  },
  components: {
    DelDialog
  },
  data() {
    return {
      msFormatting: msFormatting,
      dcInfoCache: [],
      isTimeRunning: false,
      activeName: "first",
      currentTab: "first",
      detail_list_loading: false,
      sheet_list: [],
      current_program_list: [],
      get_schedule_program_merge: [],
      deletePlanVisible: false,
      currentDeletePlan: null
    }
  },
  methods: {
    async setSchedule(isPlay) {
      await sendCommandKp('multiple', this.dcInfoCache, "set", {
        methodName: "scheduleRunning",
        methodParams: { boolRun: isPlay }
      });
      await this.isScheduleRunning();
      this.myWebSocket.onmessage = (val) => {
        if (JSON.parse(val.data).type == "invoke_method" && JSON.parse(val.data).data.uri == 'isScheduleListRunning') {
          let response = JSON.parse(val.data);
          let data = response.data.response;
          this.isTimeRunning = JSON.parse(data).isRunning;
          if (this.isTimeRunning) {
            this.$msg({
              type: 'success',
              message: this.$t('terminal.timePlayOpenTip')
            })
          } else {
            this.$msg({
              type: 'success',
              message: this.$t('terminal.timePlayCloseTip')
            })
          }
          console.log('run', this.isTimeRunning)
        }
      }
    },
    changeTimeRunning() {
      this.setSchedule(this.isTimeRunning);
      if (this.currentTab == 'first') {
        this.get_parogram_list(true)
      } else if (this.currentTab == 'second') {
        this.getProgramSheetList();
      }
    },
    getScheduleProgramList() {
      sendCommandKp('multiple', this.dcInfoCache, "get", {
        methodName: "getScheduleList",
        methodParams: {}
      });
      this.myWebSocket.onmessage = (val) => {
        if (JSON.parse(val.data).type == "invoke_method" && JSON.parse(val.data).data.uri == 'getScheduleList') {
          let res = JSON.parse(val.data)
          let response = JSON.parse(res.data.response);
          if (response.code == 200) {
            this.get_schedule_program_merge = response.data;
            this.get_schedule_program_merge.forEach(ele => {
              ele.weekList = daysWeek(ele.validWeek)
            })
          }
        }
      }
    },
    getProgramSheetList() {
      let user_id = this.$cookies.get("user_id");
      this.detail_list_loading = true;
      this.$http.post(
        detailCommand, {
        commands_info: uriEncode([{
          device_id: this.currentDetail.id,
          sn: this.currentDetail.sn,
          msg: {
            id: this.currentDetail.id,
            sn: this.currentDetail.sn,
            groupName: user_id,
            type: "get_program_sheet_list",
          },
        },]),
      }
      );
      this.myWebSocket.onmessage = (val) => {
        //console.log('!!!!!!!!!!', JSON.parse(val.data).type)
        if (JSON.parse(val.data).type == "get_program_sheet_list") {
          this.sheet_list = JSON.parse(val.data).data.data;
          //console.log('sheet_list', this.sheet_list);
          let j = 1;
          let key = 1;
          this.sheet_list.forEach(ele => {
            let play_count = ele.usePlayTimeList
            let i = 0;
            ele.index = j;
            j += 1;
            ele.key = key;
            key += 1;
            ele.programlist.forEach(item => {
              item.key = key;
              key += 1;
              if (play_count[i] == 0) {
                item.finaldata = ele.playCountList[i];
              } else {
                item.finaldata = secToHMS(ele.playTimeList[i] / 1000).split();
              }
              i++;
            })
          })
          this.detail_list_loading = false;
        }

      }
    },
    get_parogram_list(isSocket = false) {
      let user_id = this.$cookies.get("user_id");
      this.detail_list_loading = true;
      this.playListLoad = true;
      this.$http.post(detailCommand, {
        commands_info: uriEncode([{
          device_id: this.currentDetail.id,
          sn: this.currentDetail.sn,
          msg: {
            id: this.currentDetail.id,
            sn: this.currentDetail.sn,
            groupName: user_id,
            type: "get_program_list",
          },
        },]),
      });
      if (isSocket) {
        this.myWebSocket.onmessage = (val) => {
          if (JSON.parse(val.data).type == 'get_program_list') {
            let data = JSON.parse(val.data);
            let program_list = data.data.data;
            this.current_program_list = program_list;
            this.detail_list_loading = false;
            this.playListLoad = false;
            // this.current_program_list.forEach((ele) => {
            //   ele.playTime = secToHMS(ele.playTime)
            // })
          }
        }
      }
    },
    handleClick(tab) {
      this.currentTab = tab.name;
      if (tab.name == 'third') {
        if (this.currentDetail.run_state) {
          this.getScheduleProgramList();
        }
      } else if (tab.name == 'second') {
        if (this.currentDetail.run_state) {
          this.getProgramSheetList();
        }
      } else if (tab.name == 'first') {
        if (this.currentDetail.run_state) {
          this.get_parogram_list();
          // 需要接触......
          this.myWebSocket.onmessage = (val) => {
            if (JSON.parse(val.data).type == 'get_program_list') {
              let data = JSON.parse(val.data);
              let program_list = data.data.data;
              this.current_program_list = program_list;
              this.detail_list_loading = false;
              this.playListLoad = false;
              //console.log("program_list", this.current_program_list);
              // this.current_program_list.forEach((ele) => {
              //   ele.playTime = secToHMS(ele.playTime)
              // })
            }

          }
        }
      }
    },
    handleDeleteSchedule() {

    },
    handleStopPlan(row, plan_type) {
      sendCommandKp('multiple', this.dcInfoCache, "set", {
        methodName: "program/play",
        methodParams: { id: row.id }
      });
      this.myWebSocket.onmessage = (val) => {
        if (JSON.parse(val.data).type == "invoke_method" && JSON.parse(val.data).data.uri == 'program/play') {
          let response = JSON.parse(val.data);
          if (JSON.parse(response.data.response).code == 200) {
            this.$msg({
              type: 'success',
              message: this.$t('terminal.programChangeTip')
            })
            if (plan_type == 1) {
              this.get_parogram_list(true);
            } else if (plan_type == 2) {
              this.getProgramSheetList();
            }
          } else {
            this.$msg({
              type: 'warning',
              message: this.$t('terminal.timePlayTips')
            })
          }
        }
      }
    },
    handleNoPlan() {
      this.$msg({
        type: 'warning',
        message: this.$t('terminal.programIsPlaying')
      })
    },
    handlePlanDelete(row) {
      this.deletePlanVisible = true;
      this.currentDeletePlan = row;
    },
    async isScheduleRunning() {
      //判断当前设备是否正在定时播放
      await sendCommandKp('multiple', this.dcInfoCache, "get", {
        methodName: "isScheduleListRunning",
        methodParams: {}
      });
    },
    confirmDeletePlan(isConfirm) {
      if (isConfirm) { //节目列表删除
        if (this.currentTab == 'first' || this.currentTab == 'second') {
          sendCommandKp('multiple', this.dcInfoCache, "set", {
            methodName: "program/delete",
            methodParams: { id: this.currentDeletePlan.id }
          });
          //this.get_parogram_list(true);
          this.myWebSocket.onmessage = (val) => {
            if (JSON.parse(val.data).type == 'invoke_method' && JSON.parse(val.data).data.uri == 'program/delete') {
              let res = JSON.parse(val.data);
              if (JSON.parse(res.data.response).code == 200) {
                this.$msg({
                  type: 'success',
                  message: "节目删除成功"
                })
                if (this.currentTab == 'first') {
                  this.get_parogram_list(true)
                } else if (this.currentTab == 'second') {
                  this.getProgramSheetList();
                } else if (this.currentTab == "third") {
                  this.getScheduleProgramList();
                }

              } else {
                //console.log(res.data.response)
                this.$msg({
                  type: 'warning',
                  message: JSON.parse(res.data.response).message
                })
              }
            }
          }
        }
      }
      this.deletePlanVisible = false;
    },
  },
  computed: {
    myWebSocket() {
      return this.$store.getters.myWebSocket;
    },
  },
  created() {
    this.dcInfoCache = [{
      id: this.currentDetail.id,
      sn: this.currentDetail.sn,
      type_id: this.currentDetail.type_id,
      name: this.currentDetail.name,
      cache: {}
    }];
    if (this.currentDetail.run_state) {
      this.getScheduleProgramList();
      this.get_parogram_list();
      this.isScheduleRunning();
    }
    // 需要接触......
    this.myWebSocket.onmessage = (val) => {
      if (JSON.parse(val.data).type == 'get_program_list') {
        let data = JSON.parse(val.data);
        let program_list = data.data.data;
        this.current_program_list = program_list;
        this.detail_list_loading = false;
        this.playListLoad = false;
        //console.log("program_list", this.current_program_list);
        // this.current_program_list.forEach((ele) => {
        //   ele.playTime = secToHMS(ele.playTime)
        // })
      } else if (JSON.parse(val.data).type == "invoke_method" && 'isScheduleListRunning' == JSON.parse(val.data).data.uri) {
        let response = JSON.parse(val.data);
        let data = response.data.response;
        this.isTimeRunning = JSON.parse(data).isRunning;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-table__header-wrapper {
  .cell {
    font-size: 18px;
    color: #2fb3ff;
  }

  th:last-child > .cell {
    text-align: center;
  }
}

.play-list {
  width: 100%;
  height: 100%;

  .plan_control_list {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .control {
      width: 96%;
      height: 100%;

      display: flex;

      justify-content: space-between;

      .left_button {
        width: 100%;
        height: 100%;
        position: relative;

        .control_order {
          position: absolute;
          display: flex;
          align-items: center;
          height: 40px;
          right: 20px;
          z-index: 999;
        }

        .list_table {
          width: 100%;
          height: calc(100% - 80px);
          margin: 0 auto;

          .table_content {
            width: 100%;
            height: calc(100vh - 250px);
            margin: 10px auto;

            .con_button {
              display: flex;
              align-items: center;
              width: 60px;
              justify-content: space-between;
            }

            .i_img {
              width: 30px;
              height: 30px;
              cursor: pointer;

              img {
                height: 30px;
                width: 30px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
